import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchMachines, fetchMachineDownloadCSV } from '../actions/machines'

import MachineList from '../components/MachineList'
import ErrorMessage from '../components/ErrorMessage'
import MachinesCashSummary from "../components/MachinesCashSummary";
import '../styles/MachinesAdminView.css'

class MachinesView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      summaryOpen: false,
    }

    this.toggle = this.toggle.bind(this);
    this.handleMachineDownloadCSV = this.handleMachineDownloadCSV.bind(this)
  }

  toggle() {
    this.setState({
      summaryOpen: !this.state.summaryOpen
    })
  }

  componentDidMount() {
    this.props.fetchMachines()
  }

  handleMachineDownloadCSV() {
    const { fetchMachineDownloadCSV } = this.props

    fetchMachineDownloadCSV();
  }

  render() {
    const { machines, error, role, type } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!machines) {
      return (<div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>)
    }

    return (
      <div className="machines-admin-view">
        <div className="mach-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-desktop mr-3"></i>
                <span className="text-vw-dark mr-1">Parque de</span>
                <span className="text-vw-light">Ones</span>
              </h1>
            </div>
            {role === 'ADMIN' && (type === 'MASTER') && (
              <div className="header-actions">
                <Link to="/machines/add" className="mach-admin-btn primary">
                  <i className="fas fa-plus"></i>
                  <span>Nueva Máquina</span>
                </Link>
                <button className="mach-admin-btn secondary" onClick={e => this.toggle()}>
                  <i className="fas fa-expand"></i>
                  <span>Ver cash parque</span>
                </button>
                <button className="mach-admin-btn success" onClick={this.handleMachineDownloadCSV}>
                  <i className="fas fa-file-excel"></i>
                  <span>Descargar Listado</span>
                </button>
              </div>
            )}
          </div>
        </div>
        {this.state.summaryOpen && (
          <div>
            <MachinesCashSummary machines={machines} />
            <br />
            <hr />
            <br />
          </div>
        )}
        <MachineList machines={machines} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  machines: state.machines.machines,
  error: state.machines.error,
  role: state.auth.role,
  type: state.auth.type,
})

const mapDispatchToProps = dispatch => ({
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  fetchMachineDownloadCSV: bindActionCreators(fetchMachineDownloadCSV, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(MachinesView)
